/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { FlexBox, Title, MessageBox, MessageBoxAction, Text } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import { uiDialogTitle } from '../../Styling/Theme/Theme';
import { useTranslations } from '../../hooks/useTranslations';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { declineFeedback, provideFeedback, resetAppContextData } from '@/store/feedbackSlice';
import { PushType } from '@sap-px/pxapi';

export const InvitationDialog = () => {
    const { t } = useTranslations();
    const dispatch = useAppDispatch();
    const selector = useAppSelector(state => state.feedbackReducer);

    let declineMessage;
    if (selector.pushType === PushType.instantPush) {
        declineMessage = t('NOT_NOW');
    } else if (selector.pushType === PushType.timedPush) {
        declineMessage = t('ASK_ME_LATER');
    }

    return (
        <MessageBox
            open={selector.invitationDialogIsOpen}
            data-testid="survey-invitation-dialog"
            accessibleName="Survey Invitation Dialog"
            header={
                <FlexBox
                    fitContainer
                    alignItems="Start"
                    justifyContent="Start"
                    style={{
                        margin: `${ThemingParameters.sapContent_Margin_Small} 0`,
                    }}
                >
                    <Title level="H2" style={{ ...uiDialogTitle }}>
                        {t('INVITATION_DIALOG_TITLE')}
                    </Title>
                </FlexBox>
            }
            actions={[MessageBoxAction.Yes, declineMessage]}
            emphasizedAction={MessageBoxAction.Yes}
            initialFocus={MessageBoxAction.Yes}
            onClose={action => {
                if (action === MessageBoxAction.Yes) {
                    dispatch(provideFeedback());
                } else {
                    dispatch(declineFeedback());
                }
                dispatch(resetAppContextData());
            }}
        >
            <FlexBox
                style={{
                    gap: ThemingParameters.sapContent_Gap,
                }}
                direction="Column"
            >
                <Text>{t('INVITATION_DIALOG_MESSAGE')}</Text>
            </FlexBox>
        </MessageBox>
    );
};
